import React from "react";
import MiniTableContainer from "../../common/miniTable/MiniTableContainer";
import {projectDashInfoAPI, requestDashInfoAPI} from "../../../services/client";
import {ProjectDashInfoResponseData, RequestDashInfoResponseData} from "../../../types/client";
import styles from "./ProjectInfoCard.module.css"

interface Column<T> {
    key: string;
    header: string;
    width?: string;
    render?: (value: T) => React.ReactNode;
}

//날짜 데이터 형식 변환, 없으면 '-', 있으면 시간 데이터 제외
const formatDateToString = (date: Date | string): string => {
    if (!date) return '';
    const dateObj = date instanceof Date ? date : new Date(date);

    if (isNaN(dateObj.getTime())) {
        return '-';
    }
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

//프로젝트 현황 테이블 컬럼
const projectColumns: Column<ProjectDashInfoResponseData>[] = [
    {key: 'projectName', header: '프로젝트명', width: '25%'},
    {key: 'projectStatus', header: '작업 여부', width: '25%'},
    {
        key: 'progress',
        header: '진행 척도',
        width: '25%',
        render: (project: ProjectDashInfoResponseData) => `${project.progress}%`
    },
    {
        key: 'deadline',
        header: '작업 종료 예정일',
        width: '25%',
    }
];

//요청 현황 테이블 컬럼
const requestColumns: Column<RequestDashInfoResponseData>[] = [
    {key: 'requestType', header: '요청사항', width: '25%'},
    {
        key: 'createdAt',
        header: '요청일자',
        width: '25%',
        render: (request: RequestDashInfoResponseData) => formatDateToString(request.createdAt)
    },
    {key: 'status', header: '처리상태', width: '25%'},
    {
        key: 'confirmedAt',
        header: '처리일자',
        width: '25%',
        render: (request: RequestDashInfoResponseData) => formatDateToString(request.confirmedAt)
    }
];

//프로젝트 현황 정보 조회 카드
const ProjectInfoCard = () => {
    //탭 버튼
    const tabs = [
        //프로젝트 현황
        {
            id: 'projects',
            label: 'Projects',
            fetchData: async (page: number) => projectDashInfoAPI(page, 3),
            columns: projectColumns,
        },
        //요청 현황
        {
            id: 'requests',
            label: 'Requests',
            fetchData: async (page: number) => requestDashInfoAPI(page, 3),
            columns: requestColumns
        }
    ];

    return (
        <div className={styles.container}>
            {/*미니 테이블*/}
            <MiniTableContainer
                tabs={tabs}
                size="medium"
                itemsPerPage={3}
                className={styles.topPadding}
            />
        </div>
    );
};

export default ProjectInfoCard;